module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_voice2-242de2e4afa8e48225c3d4d88da87832.png";